import { api } from "@api/api";
import { Optional } from "@shared/types";
import { Category } from "@modules/categorys/types";
import { CategoryFormValues } from "@modules/categorys/validations";

export async function editCategoryService(id: string, data: Optional<CategoryFormValues, "name">): Promise<Category> {
  const { data: category } = await api.patch<Category>(`v1/category_admin/${id}/`, data);

  return category;
}
